module.exports = __webpack_public_path__ + "img/ledger-city-api.0dc06a3f.png";